//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { object, string, mixed, addMethod, number } from "yup";
import * as yup from "yup";
import moment from "moment";

addMethod(mixed, "isDateValid", isDateValid);
addMethod(mixed, "isValidPhoneNumber", isValidPhoneNumber);
function getErrorsFromValidationError(validationError) {
  const FIRST_ERROR = 0;
  return validationError.inner.reduce((errors, error) => {
    return {
      ...errors,
      [error.path]: error.errors[FIRST_ERROR],
    };
  }, {});
}

function handleErrorMeg(msg, schema) {
  try {
    schema.validateSync(msg, { abortEarly: false });
    return {};
  } catch (error) {
    return getErrorsFromValidationError(error);
  }
}

function isValidPhoneNumber(msg) {
  const indPhoneRegExp = /^[6-9]\d{9}$/;
  //  const usPhoneRegExp = /^(\([0-9]{3}\) |[0-9]{3})[0-9]{3}[0-9]{4}$/;
  const usPhoneRegExp = /^[2-9]\d{9}$/;
  const uaePhoneRegExp = /^(?:\+971|00971|0)?(?:50|51|52|55|56|2|3|4|6|7|9)\d{7}$/m;

  return mixed().test("isValidPhoneNumber", msg, function (value) {
    if (value) {
      if (this.parent.countryCode === "+91") {
        return indPhoneRegExp.test(value);
      }
      if (this.parent.countryCode === "+971") {
        return uaePhoneRegExp.test(value);
      }
      return usPhoneRegExp.test(value);
    }
    return false;
  });
}

function isDateValid(msg) {
  return mixed().test("isDateValid", msg, function (value) {
    value = parseInt(value, 10);
    if (!value || isNaN(value)) return false;
    var isValid = new Date(value).getTime() > 0;
    return isValid;
  });
}

const loginSchema = object().shape({
  email: string()
    .required("Email cannot be blank")
    .email("Enter a valid email address."),
  password: string().required("Password cannot be blank"),
  org: string().required("Organization cannot be blank"),
});

const emailSchema = object().shape({
  email: string()
    .required("Enter a valid email address.")
    .email("Enter a valid email address."),
});

const otpSchema = object().shape({
  otp: string().required("Otp cannot be blank"),
});

const signupDetailsSchema = object().shape({
  firstName: string().required("First name cannot be empty"),
  lastName: string().required("Last name cannot be empty"),
  email: string()
    .required("Email cannot be empty")
    .email("Enter a valid email address"),
  role: string().required("Role cannot be empty")
  // password: ''
    // .string()
    // .required("Password cannot be blank.")
    // .test("len", "Must be atleast 6 characters", (val) => val.length > 7)
    // .matches(
    //   /^(?=.*\d)(?=.*[!@#$%^&*.])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
    //   "Password format incorrect."
    // ),
});

const createContractCodeSchema = object().shape({
  shipto: string().required("Shipto cannot be empty"),
  billto: string().required("Billto cannot be empty"),
  pmaType: string().required("PMA Type cannot be empty").max(10),
  contractCode: string().required("Contract Code cannot be empty").max(10),
  loyalty: string().required("loyalty cannot be empty"),
  systemManaged: string().required("System Managed cannot be empty"),
});

const forgotPasswordSchema = object().shape({
  email: string()
    .required("Enter a valid email address.")
    .email("Enter a valid email address."),
  org: string().required("Organization cannot be blank"),
});

const resetPasswordSchema = object().shape({
  password: yup
    .string()
    .required("Password cannot be blank.")
    .test("len", "Must be atleast 6 characters", (val) => val.length > 7)
    .matches(
      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      "Password format incorrect."
    ),
});

const customerLoginSchema = object().shape({
  firstName: string().required("Enter a valid first name."),
  lastName: string().required("Enter a valid last name."),
  email: string().required("Enter a valid role."),
  // password: yup
  // 	.string()
  // 	.required('Password cannot be blank.')
  // 	.test('len', 'Must be atleast 6 characters', (val) => val.length > 7)
  // 	.matches(/^(?=.*\d)(?=.*[!@#$%^&*.])(?=.*[a-z])(?=.*[A-Z]).{8,}$/, 'Password format incorrect.'),
  // userName: string().required('Enter a user name.'),
  role: string().required("Enter a valid role."),
  integrationUserId: string().required("Enter a integration user id."),
  currentCustomerId: string().required("Enter a current customer no."),
  // associatedCustomerId: string().required('Enter a associated customer no.'),
  loyaltyAccountType: string().required("Enter a loyalty account type."),
});

export function loginValidate(values) {
  return handleErrorMeg(values, loginSchema);
}

export function emailValidate(values) {
  return handleErrorMeg(values, emailSchema);
}

export function otpValidate(values) {
  return handleErrorMeg(values, otpSchema);
}

export function signupDetailsValidate(values) {
  return handleErrorMeg(values, signupDetailsSchema);
}
export function forgotPasswordValidate(values) {
  return handleErrorMeg(values, forgotPasswordSchema);
}

export function resetPasswordValidate(values) {
  return handleErrorMeg(values, resetPasswordSchema);
}

export function customerLoginValidate(values) {
  return handleErrorMeg(values, customerLoginSchema);
}

export function createContractCodeValidate(values) {
  return handleErrorMeg(values, createContractCodeSchema);
}
